module.exports = __webpack_public_path__ + "img/island-display.bae6e68f.png";